module.exports = __webpack_public_path__ + "static/media/triangle-bottom.6e3d9e59.svg";